// extracted by mini-css-extract-plugin
export default {"TableHeader":"AuditTrailTable_TableHeader__SKOs0","Icon":"AuditTrailTable_Icon__fBdif"};